import apiService from './apiService';

const accountService = {
  async fetchAccounts() {
    try {
      return await apiService.get('/accounts');
    } catch (error) {
      console.error('Error fetching accounts:', error);
      throw error;
    }
  },

  async fetchAccount(id) {
    try {
      return await apiService.get(`/accounts/${id}`);
    } catch (error) {
      console.error(`Error fetching account ${id}:`, error);
      throw error;
    }
  },

  async createAccount(accountData) {
    try {
      return await apiService.post('/accounts', accountData);
    } catch (error) {
      console.error('Error creating account:', error);
      throw error;
    }
  },

  async updateAccount(id, accountData) {
    try {
      return await apiService.put(`/accounts/${id}`, accountData);
    } catch (error) {
      console.error(`Error updating account ${id}:`, error);
      throw error;
    }
  },

  async deleteAccount(id) {
    try {
      return await apiService.delete(`/accounts/${id}`);
    } catch (error) {
      console.error(`Error deleting account ${id}:`, error);
      throw error;
    }
  },

  async fetchAccountSites(id) {
    try {
      return await apiService.get(`/accounts/${id}/sites`);
    } catch (error) {
      console.error(`Error fetching account ${id} sites:`, error);
      throw error;
    }
  },

  async updateAccountSites(id, siteIds) {
    try {
      return await apiService.put(`/accounts/${id}/sites`, { siteIds });
    } catch (error) {
      console.error(`Error updating account ${id} sites:`, error);
      throw error;
    }
  }
};

export default accountService;
